import ApiResponse from "../interfaces/ApiResponse";

export const getNextPageParam = <TResponse>(
  lastPage: ApiResponse<TResponse>,
) => {
  const { currentPage, totalPages } = lastPage.meta;
  return currentPage < totalPages ? currentPage + 1 : undefined;
};
